import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import DocumentDefinitionsEditor from "./DocumentDefinitionsEditor";

const DocumentDefinitionsEditorPage = () => {
  const { documentDefinitionId } = useParams();
  const navigate = useNavigate();
  const [documentDefinition, setDocumentDefinition] = useState(null);
  const [loading, setLoading] = useState(true);

  const isNew = documentDefinitionId === "new";

  const createEmptyDocumentDefinition = () => ({
    _id: crypto.randomUUID(),
    type: "",
    name: "",
    generalDirection: "",
    segments: [],
    createdDate: new Date().toISOString(),
  });

  useEffect(() => {
    const fetchDocumentDefinition = async () => {
      if (isNew) {
        setDocumentDefinition(createEmptyDocumentDefinition());
        setLoading(false);
      } else {
        try {
          const res = await fetch(`https://documents.poc.mrc.ai/api/definitions/${documentDefinitionId}`);
          const data = await res.json();
          setDocumentDefinition(data);
        } catch (error) {
          console.error("Error fetching document definition:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchDocumentDefinition();
  }, [documentDefinitionId, isNew]);

  const handleSave = async (updatedDocumentDefinition) => {
  try {
    const method = isNew ? "POST" : "PUT";
    const url = isNew
      ? `https://documents.poc.mrc.ai/api/definitions`
      : `https://documents.poc.mrc.ai/api/definitions/${documentDefinitionId}`;

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedDocumentDefinition),
    });

    if (!res.ok) throw new Error("Failed to save document definition");

    const saved = await res.json();
    setDocumentDefinition(saved);
  } catch (err) {
    console.error("Error saving document definition:", err);
  }
};

  const handleClose = () => navigate("/");

  if (loading) return <Spinner />;

  return <DocumentDefinitionsEditor documentDefinition={documentDefinition} onClose={handleClose} isNew={isNew} />;
};

export default DocumentDefinitionsEditorPage;
